export const cacheConfig = {
    prefix: 'dealers_',
    driver: 'session',
    ttl: 60 * 60 * 2 * 1000 // 2 hours
};

export const apiBaseUrl = window.location.hostname.includes('.test')
    ? 'http://dealerscore.test'
    : 'https://dealerscore.aws.wehaa.net';
